import { Button, DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningToolPanel extends Layout {
    buttonAssign: Button;
    buttonCarrierSelection: Button;
    buttonConvertSpotToOrder: Button;
    buttonDispatch: Button;
    buttonHold: Button;
    buttonLaneHistory: Button;
    buttonLoadboard: Button;
    buttonRateOrders: Button;
    buttonRefreshLoadPosting: Button;
    buttonReleaseToBilling: Button;
    buttonRemoveCarrier: Button;
    buttonSendRateConfirmation: Button;
    buttonSendTender: Button;
    buttonTerminalInfo: Button;
    buttonTopMatch: Button;
    buttonUpdateField: Button;
    panelButtons: Panel;
    panelLeft: Panel;
    panelRight: Panel;
    sourceMovement: DataSource;
}
